import React, { useEffect, useState } from "react";

export default function ExcelDownloadToast({
  visible,
  progress,
  status,
  processedCount,
  totalCount,
  currentSheet = "",
  onClose
}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsVisible(true);
    } else {
      handleClose();
    }
  }, [visible]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose && onClose();
    }, 300);
  };

  // 🔥 mapear estados a tu sistema de colores
  let bgColor;
  let borderColor;

  switch (status) {
    case "done":
      bgColor = "bg-green-500";
      borderColor = "border-green-700";
      break;
    case "fetching":
    case "processing":
    case "generating":
      bgColor = "bg-blue-500";
      borderColor = "border-blue-700";
      break;
    case "error":
      bgColor = "bg-red-500";
      borderColor = "border-red-700";
      break;
    default:
      bgColor = "bg-blue-500";
      borderColor = "border-blue-700";
  }

  const statusText = {
    fetching: "Obteniendo datos...",
    processing: "Procesando datos...",
    generating: "Generando Excel...",
    done: "Descarga lista",
    error: "Error en la descarga"
  };

  if (!visible) return null;

  return (
    <div
      className={`w-[15rem] fixed top-5 right-5 z-50 p-4 rounded-md shadow-lg border-l-4 ${bgColor} ${borderColor} text-white flex flex-col gap-2 transition-all duration-300 ease-in-out transform ${
        isVisible ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
      }`}
    >
      {/* 🔥 HEADER */}
      <div className="flex justify-between items-center">
        <span className="font-semibold text-sm">
          {statusText[status]}
        </span>

        <button
          onClick={handleClose}
          className="ml-2 text-white hover:text-gray-200 text-sm"
        >
          ✕
        </button>
      </div>

      {/* 🔥 HOJA */}
      {currentSheet && (
        <span className="text-xs opacity-90">
          {currentSheet}
        </span>
      )}

      {/* 🔥 PROGRESS BAR */}
      <div className="w-full bg-white/30 rounded-full h-2">
        <div
          className="bg-white h-2 rounded-full transition-all"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* 🔥 FOOTER */}
      <div className="flex justify-between text-xs">
        <span>
          {processedCount?.toLocaleString()} / {totalCount?.toLocaleString()}
        </span>
        <span>{progress}%</span>
      </div>
    </div>
  );
}